import { useContext } from 'react';

import { LoadSavedQuotation } from '../components';
import { StepOne, StepTwo, StepThree, StepFour } from '../Steps';

import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepFourFormProvider } from '../Steps/StepFour/components/Form/contexts/StepFourForm';
import { StepOneFormProvider } from '../../shared/contexts';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts/StepThreeForm';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts/StepTwoForm';
import { WizardDataFormProvider } from './contexts/WizardDataForm/WizardDataFormProvider';

import { QuotationStep } from '../../shared/interfaces';
import { LoadRenewalQuotation } from '../components/LoadRenewalQuotation';

export const WizardConsortiumIntegral = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } =
    useContext(QuotationInfoContext);
  
  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:        
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      default:
        break;
    }
  };

  return (
    <StepOneFormProvider>
      <WizardDataFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            <StepFourFormProvider>
              {getStepComponent()}
              {loadingRenewalQuotation ? <LoadRenewalQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : null}
            </StepFourFormProvider>
          </StepThreeFormProvider>
        </StepTwoFormProvider>
      </WizardDataFormProvider>
    </StepOneFormProvider>
  );
};
